<template>
  <form id="formChecklist" @submit.prevent="submitForm" class="ajax_off">
    <div class="form-group">
      <label>Selecionar checklist</label>
      <div class="clearfix"></div>
      <e-select v-model="checklist_selecionada" :route="`checklist/selectList/${this.cliente_id}`" />     
    </div>
  </form>
</template>
<script>
export default {
  props: {
    cliente_id: "",
    tarefa_id: "",
  },
  data() {
    return {
      checklist_selecionada: "",      
    };
  },
  methods: {  
    async submitForm() {
      const result = await this.$api.post("tarefa/addChecklist", {
        checklist_id: this.checklist_selecionada,
        tarefa_id: this.tarefa_id,
      });

      if (result.data.ok) {
        this.$emit("updateCartao");
        this.$bvModal.hide("checklist");
      }
    },
  },
};
</script>